import { useTranslation } from "react-i18next";
import { Button, Card } from "react-native-paper";
import CardContainer from "../CardContainer";
import {
	type ActivityLogItem,
	ActivityLogListItem,
} from "./ActivityLogListItem";

type Props = {
	title: string;
	subtitle: string;
	icon: string;
	items: ActivityLogItem[];
	onItemPress: (item: ActivityLogItem) => void;
	onViewAll: () => void;
};

export const ActivityLogCard = ({
	title,
	subtitle,
	icon,
	items,
	onItemPress,
	onViewAll,
}: Props) => {
	const { t } = useTranslation();

	return (
		<CardContainer title={title} subtitle={subtitle} icon={icon}>
			{items.map((item, index) => (
				<ActivityLogListItem
					key={`${item.title}-${index}`}
					item={item}
					onPress={() => onItemPress(item)}
				/>
			))}
			<Card.Actions>
				<Button onPress={onViewAll} mode="text">
					{t("common.viewAll")}
				</Button>
			</Card.Actions>
		</CardContainer>
	);
};
